import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { TransactionResult } from '../interfaces/TransactionResult';
import { Observable, merge, Subject } from 'rxjs';
import { ToastService } from './toast.service';
import { tap } from 'rxjs/operators';
import { AuthService } from './auth.service';
//import { TranslateApplicationService } from '../../translate/translate-application-service';

export let self: RestCallService;

export abstract class RestCallService {
  private urlBase: string = '';
  private authService = inject(AuthService);

  constructor(public http: HttpClient
    , urlKey: string
    , public toastr: ToastService
    //, public notificationService: NotificationService,
    //public translate: TranslateApplicationService
  ) {
    self = this;
    self.urlBase = (<any>window).configuration.enviroment[urlKey];
    if (!Boolean(self.urlBase)) {
      throw Error("property urlBase:string is not defined inside enviroment variables on quetzalcoatl maintenance");
    }
    
  }

  setUrlKey(urlKey: string): void {
    self.urlBase = (<any>window).configuration.enviroment[urlKey];
    if (!Boolean(self.urlBase)) {
      throw Error("property urlBase:string is not defined inside enviroment variables on quetzalcoatl maintenance");
    }
  }

  private getFullUrl(url: string): string {
    return self.urlBase + url;
  }

  private success(data: TransactionResult<any>): void {
    if (data.success) {
      if (Boolean(data.message)) {
        //self.toastr.info(data.translateParams ? self.translate.translateKeyWithParameters(data.message, data.translateParams) : `${self.translate.translateKey(data.message)}`);
        self.toastr.success(data.translateParams ? data.message : data.message);
      }
      if (Boolean(data.messages)) {
        for (let item of data.messages) {
          //self.notificationService.info(data.translateParams ? self.translate.translateKeyWithParameters(item, data.translateParams) : self.translate.translateKey(item) != undefined ? `${self.translate.translateKey(item)}` : item);
          self.toastr.success(data.translateParams ? item: item);
        }
      }
    }
    if (!data.success) {
      /*if (self.translate != null) {
        if (data.message != null) {
          self.notificationService.error(data.translateParams ? self.translate.translateKeyWithParameters(data.message, data.translateParams) : `${self.translate.translateKey(data.message)}`);
        }
        if (Boolean(data.messages)) {
          for (let item of data.messages) {
            self.notificationService.error(`${self.translate.translateKey(item)}`);
          }
        }
      }*/
      if (data.message != null) {
          self.toastr.error(data.translateParams ? data.message : data.message);
      }
      if (Boolean(data.messages)) {
        for (let item of data.messages) {
          self.toastr.error(data.translateParams ? item: item);
        }
      }
    }
  }

  private error(error: HttpErrorResponse): void {
    var message = error.error?.message || error.message || 'An error occurred';

    if (error.status === 401) {
      self.toastr.warn(message);
      self.authService.logout();
    }
    if (error.status === 500) {
      self.toastr.error(message);
    }
    if (error.status === 404) {
      self.toastr.warn(message);
    }
    if (error.status === 0 && !error.url?.includes("SaveHistory") && !error.url?.includes("status/GetActive")) {
      self.toastr.warn(message);
    }
    if (error.status === 405) {
      self.toastr.warn(message);
    }if(error.status === 400){
      self.toastr.error( JSON.stringify(error.error.errors));
    }
  }

  /*
   *
   *http get 
   * 
   */
  public get<TResult>(url: string, data?: any, headers?: HttpHeaders | any): Observable<TransactionResult<TResult>> {
    if (!Boolean(headers)) {
      headers = {};
    }

    return self.http.get<TransactionResult<TResult>>(self.getFullUrl(url), {
      headers: Object.assign(headers, {
        'urlBase': self.urlBase
      }),
      params: data
    }).pipe(tap(self.success, self.error));
  }

  /*
   *
   *http post 
   * 
   */
  public post<TResult>(url: string, data?: any, headers?: HttpHeaders | any): Observable<TransactionResult<TResult>> {
    if (!Boolean(headers)) {
      headers = {};
    }
    return self.http.post<TransactionResult<TResult>>(self.getFullUrl(url), data, {
      headers: {
        'urlBase': self.urlBase
      }
    }).pipe(tap(self.success, self.error));
  }


  /*
   *
   *http put 
   * 
   */
  public put<TResult>(url: string, data?: any, headers?: HttpHeaders | any): Observable<TransactionResult<TResult>> {
    if (!Boolean(headers)) {
      headers = {};
    }
    return self.http.put<TransactionResult<TResult>>(self.getFullUrl(url), data, {
      headers: {
        'urlBase': self.urlBase
      }
    }).pipe(tap(self.success, self.error));
  }


  /*
   *
   *http delete
   * 
   */
  public delete<TResult>(url: string, params?: any, headers?: HttpHeaders | any): Observable<TransactionResult<TResult>> {
    if (!Boolean(headers)) {
      headers = {};
    }
    return self.http.delete<TransactionResult<TResult>>(self.getFullUrl(url), {
      headers: {
        'urlBase': self.urlBase
      }, params: params
    }).pipe(tap(self.success, self.error));
  }
}

